import { render, staticRenderFns } from "./liveReviewDetails.vue?vue&type=template&id=cb623536&scoped=true"
import script from "./liveReviewDetails.vue?vue&type=script&lang=js"
export * from "./liveReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./liveReviewDetails.vue?vue&type=style&index=0&id=cb623536&prod&lang=less&scoped=true"
import style1 from "./liveReviewDetails.vue?vue&type=style&index=1&id=cb623536&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb623536",
  null
  
)

export default component.exports